import Block from "Mixins/Block";

export default Block("component-accordion", {
  fn: {},
  onLoad() {
    const items = document.querySelectorAll(`${this.selector}__item button`);
    if (items !== undefined && items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        items[i].addEventListener("click", function () {
          const parent = this.parentElement.parentElement;
          let content = this.parentElement.parentElement.lastElementChild;
          if (parent.classList.contains("component-accordion__item--active")) {
            parent.classList.remove("component-accordion__item--active");
            this.setAttribute("aria-expanded", "false");
          } else {
            parent.classList.add("component-accordion__item--active");
            this.setAttribute("aria-expanded", "true");
          }
        });
      }
    }
  },
});
